export function formatPhoneNumber(input: string) {
    if (!input) return '';

    // Remove all non-digit characters
    let digits = input.replace(/\D/g, '');

    // Add parentheses around the first two digits and a space after
    digits = digits.replace(/(\d{2})(\d)/, '($1) $2');

    // Add a dash after the next four digits
    digits = digits.replace(/(\d{4})(\d)/, '$1-$2');

    // Handle specific format for longer numbers: move one digit from after the dash to before it
    digits = digits.replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3');

    // Trim any extra digits beyond the expected format
    digits = digits.replace(/(-\d{4})\d+?$/, '$1');

    return digits;
}
